import React, { useEffect, useState, useContext } from "react"

import { Container, Row, Col } from "react-bootstrap"

import Esewa from "../../images/esewa.png"
import LeftArrow from "../../images/icons/wdn-left-chevron-blue.png"
import Paypal from "../../images/wdn-paypal.png"
import Stripe from "../../images/wdn-stripe.png"

import SEO from "../../components/seo"
import Spinner from "../spinner/spinner"
// import InputTextBox from "../input/input-text-box"
import "./payment-options.scss"
import { Link } from "gatsby"
import getCountryData from "../../utils/get-country-data"
import { GlobalAuthContext } from "../../context/authContext"

const PaymentOptions = ({ data, loading }) => {
  useEffect(() => {}, [data, loading])

  const { state } = useContext(GlobalAuthContext)

  const [payType, setPayType] = useState("")
  // const [cardDetail, setCardDetail] = useState({})

  const payTypeChange = e => {
    setPayType(e.target.value)
  }
  // const handleNameChange = e => {
  //   setCardDetail({ ...cardDetail, name: e })
  // }
  // const handleNumberChange = e => {
  //   const length = cardDetail.card_num ? cardDetail.card_num.length : 0
  //   let value = e
  //   if (e.length < 20 && /^[0-9\s]*$/.test(e)) {
  //     if (length === 3 || length === 8 || length === 13) {
  //       value += " "
  //     }
  //     setCardDetail({ ...cardDetail, number: value, card_num: e })
  //   }
  // }

  // const handleExpiryChange = e => {
  //   const length = cardDetail && cardDetail.exp ? cardDetail.exp.length : 0
  //   let value = e
  //   if (e.length < 6 && /^[0-9\/]*$/.test(e)) {
  //     if (length === 1 && e !== "") {
  //       value = e + "/"
  //     }
  //     setCardDetail({ ...cardDetail, expiry: value, exp: e })
  //   }
  // }
  // const handleCCVChange = e => {
  //   if (e.length < 4 && /^[0-9]*$/.test(e)) {
  //     setCardDetail({ ...cardDetail, ccv: e })
  //   }
  // }

  // calculates total with tax amount added
  const calculateTotal = (data, tax) => {
    return data + (data * tax) / 100
  }

  // calculates total with no tax amount added
  const getTotal = data => {
    let total = 0
    if (data && data[0]) {
      data[0].details.map(order => {
        total += order.candidate.price
        return total
      })
      return total
    }
    return total
  }
  if (loading) {
    return <Spinner />
  } else {
    return (
      <Container>
        <SEO title="Checkout" />
        <Row className="pb-5 mb-5 pt-5 mt-5">
          <Col md="5">
            <h1 className="mb-4">Checkout</h1>
            <p className="choose-pay-text">Choose your payment method</p>
            {data[0].company_country === 1 ? (
              <div className="ml-15px pay-options">
                <Col className="d-flex mb-4 align-items-center">
                  <label>
                    <input
                      name="pay-type"
                      radioGroup="pay-options"
                      type="radio"
                      value="esewa"
                      onChange={payTypeChange}
                      checked={payType === "esewa"}
                      className="mr-2 "
                    />
                    <img
                      src={Esewa}
                      className="esewa-pay-logo"
                      alt="esewa-logo"
                    />
                  </label>
                </Col>
              </div>
            ) : (
              <>
                <div className="ml-15px pay-options">
                  <Col className="d-flex mb-4 align-items-center">
                    <label>
                      <input
                        onChange={payTypeChange}
                        value="paypal"
                        checked={payType === "paypal"}
                        radioGroup="pay-options"
                        type="radio"
                        name="pay-type"
                        className="mr-2 "
                      />
                      <img src={Paypal} class="pay-logo" alt="esewa-logo" />
                    </label>
                  </Col>
                </div>
                <div className="ml-15px pay-options">
                  <Col className="d-flex mb-4 align-items-center">
                    <label>
                      <input
                        value="stripe"
                        onChange={payTypeChange}
                        checked={payType === "stripe"}
                        name="pay-type"
                        radioGroup="pay-options"
                        type="radio"
                        className="mr-2 "
                      />
                      <img src={Stripe} class="pay-logo" alt="esewa-logo" />
                    </label>
                  </Col>
                </div>
              </>
            )}

            <form
              className="payment-options"
              action={process.env.GATSBY_PAY_TEST}
              method="POST"
            >
              <input value={getTotal(data)} name="tAmt" type="hidden" />
              <input value={getTotal(data)} name="amt" type="hidden" />
              <input value="0" name="txAmt" type="hidden" />
              <input value="0" name="psc" type="hidden" />
              <input value="0" name="pdc" type="hidden" />
              <input value={data[0].order_id} name="pid" type="hidden" />

              <input
                value={`${process.env.GATSBY_ESEWA_SCD}`}
                name="scd"
                type="hidden"
              />

              <input
                value={`${process.env.GATSBY_BASE_FRONTEND}/company/checkout?type=esewa&q=success`}
                type="hidden"
                name="su"
              />
              <input
                value={`${process.env.GATSBY_BASE_FRONTEND}/company/checkout?type=esewa&q=failed`}
                type="hidden"
                name="fu"
              />
              {/* <p className="uppercase border-1px-bottom payment-details">
                Payment Details
              </p>
              <Col className="pay-details p-0">
                <InputTextBox
                  type="text"
                  label="Name on Card"
                  placeholder="john doe"
                  onChange={handleNameChange}
                  value={cardDetail.name}
                />
              </Col>
              <Col className="pay-details p-0">
                <InputTextBox
                  type="tel"
                  placeholder="1234 4568 9875 1254"
                  label="Card Number"
                  onChange={handleNumberChange}
                  value={cardDetail.number}
                />
              </Col>
              <div className="d-flex">
                <Col lg="3" className="pay-details p-0">
                  <InputTextBox
                    type="tel"
                    label="Expiration"
                    placeholder="01/21"
                    onChange={handleExpiryChange}
                    value={cardDetail.expiry}
                  />
                </Col>
                <Col lg="9" className="pay-details p-0 pl-2">
                  <InputTextBox
                    type="tel"
                    label="CCV"
                    placeholder="123"
                    onChange={handleCCVChange}
                    value={cardDetail.ccv}
                  />
                </Col>
              </div> */}
              {/* ml-15px should be added when the commented code is used. */}
              <div>
                <input
                  disabled={payType !== "esewa"}
                  type="submit"
                  className="btn-custom primary w-100 rounded"
                  value="Checkout"
                />
              </div>
            </form>
          </Col>
          <Col md="6" className="offset-md-1">
            <Row className="mb-2 mt-3 pt-5">
              <Col xs={6}>
                <p className="choose-pay-text">Summary</p>
              </Col>
              <Col xs={6} className="text-right">
                <p className="back-button text-right">
                  <img
                    src={LeftArrow}
                    className="back-icon"
                    alt="wdn-left-arrow"
                  />
                  <Link to="/company/profile/paid-cvs">Back to CVs</Link>
                </p>
              </Col>
              <Col xs={6}>
                <p>No. of CVs in Cart:</p>
              </Col>
              <Col xs={6} className="text-right">
                <p className="bold text-right">
                  {data && data[0] && data[0].details && data[0].details.length}
                </p>
              </Col>
              {/* <Col lg="5">
                <p>Subtotal:</p>
              </Col>
              <Col lg="5" className="offset-lg-2">
                <p className="bold">{getTotal(data)}</p>
              </Col>
              <Col lg="5">
                <p>Tax:</p>
              </Col>
              <Col lg="5" className="offset-lg-2">
                <p className="bold">0%</p>
              </Col> */}
              {/* for future implementation */}
            </Row>
            <div class="border-1px-bottom mb-2"></div>
            <Row>
              <Col xs={6}>
                <p>Total:</p>
              </Col>
              <Col xs={6} className="text-right">
                <p className="bold text-right">
                  {(state?.config?.country &&
                    getCountryData(
                      state?.config?.country,
                      data?.[0]?.company_country
                    )?.currency) +
                    " " +
                    calculateTotal(getTotal(data), 0)}
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    )
  }
}

export default PaymentOptions
